module.exports = __webpack_public_path__ + "static/img/CRM.9cdfcbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/leven/CRM.jpg
// module id = iNK1
// module chunks = 1